export function delay(ms: number, signal?: AbortSignal) {
   return new Promise<void>((resolve, reject) => {
      if (signal != null) {
         const abort = () => reject("delay received abort signal");

         if (signal.aborted) {
            abort();
         }
         else {
            const timeout = setTimeout(() => {
               resolve();
            }, ms);
            signal.addEventListener("abort", ev => {
               clearTimeout(timeout);
               abort();
            }, { once: true });
         }
      }
      else {
         setTimeout(() => {
            resolve();
         }, ms);
      }
   });
}
export default delay;